import { AuthenticatedTemplate } from "@azure/msal-react"
import { Stack, Box, Typography } from "@mui/material"
import React from "react"
import { useGetCompaniesQuery } from "../../../services/ConfigurationService"
import { AddCompanyDialog } from "../components/dialogs";
import { CompanyGrid } from "../components/grids";
import PageCard from '../../common/components/styled-ui-elements/PageCard';

const PAGE_STYLES = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '100vh',
    padding: 3,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 3,
    borderBottom: '2px solid #3b82f6',
    backgroundColor: '#ffffff',
  },
  content: {
    padding: 3,
    backgroundColor: '#ffffff',
  }
};

function Company() {
    const { data: companies = [], isLoading, refetch } = useGetCompaniesQuery();

    return (
        <AuthenticatedTemplate>
            <Box sx={PAGE_STYLES.container}>
                <PageCard>
                    {/* Header Section */}
                    <Box sx={PAGE_STYLES.header}>
                        <Typography variant="h5" sx={{ fontWeight: 600, color: '#1e293b' }}>
                            Manage Companies
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <AddCompanyDialog />
                        </Box>
                    </Box>

                    {/* Content Section */}
                    <Box sx={PAGE_STYLES.content}>
                        <CompanyGrid companies={companies} onCompanySaved={refetch} />
                    </Box>
                </PageCard>
            </Box>
        </AuthenticatedTemplate>
    )
}

export { Company }

